<div class="sidebar-footer">
  <p class="title">Help Desk</p>
  <p *ngIf="phone" class="info"><i class="phone" aria-hidden="true"></i>{{ phone }}</p>
  <p *ngIf="email" class="info"><i class="email" aria-hidden="true"></i>{{ email }}</p>
</div>
